/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum GeneralSkill {
  GeneralCounselExperience = "GeneralCounselExperience",
  GlobalAndCrossBorderAdvisory = "GlobalAndCrossBorderAdvisory",
  ManagingOutsideCounsel = "ManagingOutsideCounsel",
  PeopleManagement = "PeopleManagement",
  StartUpExperience = "StartUpExperience",
}

export const GeneralSkillDisplay: Record<GeneralSkill, string> = {
  [GeneralSkill.GeneralCounselExperience]: "General Counsel experience",
  [GeneralSkill.GlobalAndCrossBorderAdvisory]: "Global and Cross-Border Advisory",
  [GeneralSkill.ManagingOutsideCounsel]: "Managing Outside Counsel",
  [GeneralSkill.PeopleManagement]: "People Management",
  [GeneralSkill.StartUpExperience]: "Start-up experience",
};
